module.exports = __webpack_public_path__ + "static/media/background-login-2.a6c4e7ea.png";